import EventScope from 'owa-service/lib/contract/EventScope';
import { format } from 'owa-strings';
import { SCOPE_PARAM } from './useEventScopeFromRoute';
import { useChangeRoute } from 'mini-hooks/lib/useChangeRoute';
import { useLocation } from 'react-router-dom';

const EVENT_PREFIX = 'event';
const ID_PARAM = 'id';
const DETAILS = 'details';
const EDIT = 'edit';

const EVENT_DETAILS_TEMPLATE = `/${EVENT_PREFIX}/{0}/${DETAILS}`; // {0} is id
const EVENT_EDIT_TEMPLATE = `/${EVENT_PREFIX}/{0}/${EDIT}/{1}`; // {0} is id and {1} is scope

export const EVENT_DETAILS_ROUTE = format(EVENT_DETAILS_TEMPLATE, `:${ID_PARAM}`);
export const EVENT_EDIT_ROUTE = format(EVENT_EDIT_TEMPLATE, `:${ID_PARAM}`, `:${SCOPE_PARAM}`);

interface MoreEventDetailOperations {
    viewEventDetails: (itemId: string) => void;
    editEventDetails: (itemId: string, scope: EventScope) => void;
}

/**
 * Given an item it returns a function which on invocation opens the details form of the event
 * @param item
 */
export const useMoreEventDetailOperations = (): MoreEventDetailOperations => {
    const { pushRoute } = useChangeRoute();
    const { pathname } = useLocation();

    const viewEventDetails = (itemId: string) => {
        pushRoute(
            format(EVENT_DETAILS_TEMPLATE, encodeURIComponent(itemId)),
            true /**appendToCurrentPath */
        );
    };

    const editEventDetails = (itemId: string, scope: EventScope) => {
        // we replace /details with /edit/<scope> since both edit and delete are siblings
        pushRoute(pathname.replace(`/${DETAILS}`, `/${EDIT}/${scope}`));
    };

    return { viewEventDetails, editEventDetails };
};
